import React from "react";

import { guideData } from "../constants/GuideData";
import { faqData, categoryData } from "../constants/FaqData";
import noticeData from "../constants/NoticeData";
import { tosDataHandler } from "../constants/TosData";
import { tosPrevData } from "../constants/TosData";
import { adBannerData } from "../constants/AdBannerData";
import DOMPurify from "dompurify";

// const getParameterByName = (name: string, url: string): any => {
//    name = name.replace(/[[\]]/g, "\\$&");
//    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
//       results = regex.exec(url);
//    if (!results) return null;
//    if (!results[2]) return "";

//    const isNotUrlDecoded = decodeURIComponent(
//       results[2].replace(/\+/g, " ")
//    ).includes("%");
//    if (isNotUrlDecoded) {
//       const decodedURL = decodeURIComponent(url);
//       const newUrl = new URL(decodedURL);
//       const urlString =
//          newUrl.href.split("deferred")[0] +
//          "deferred=" +
//          decodeURIComponent(results[2].replace(/\+/g, " "));
//       return getParameterByName(name, urlString);
//    } else {
//       return decodeURIComponent(results[2].replace(/\+/g, " "));
//    }
// };

export function withVersionParams<P>(WrappedComponent: React.ComponentType<P>) {
   const fullURL = window.location.href;
   let webVersion: number = 10601;
   const url = new URL(fullURL);
   function getParameterByName(name: string, url: any): string | null {
      if (!url) {
         return null;
      }
      const value = url.searchParams.get(name);
      return value ? DOMPurify.sanitize(value) : null;
   }
   const _appVersion = getParameterByName("appVersion", url);
   const _strPrevWebVersion = window.sessionStorage.getItem("appVersion");

   if (!_strPrevWebVersion) {
      if (!_appVersion) {
         window.sessionStorage.setItem("appVersion", "10601");
      } else {
         if (/^\d+$/.test(_appVersion)) {
            window.sessionStorage.setItem("appVersion", _appVersion);
            webVersion = parseInt(_appVersion, 10);
         } else {
            window.sessionStorage.setItem("appVersion", "10601");
         }
      }
   } else {
      if (/^\d+$/.test(_strPrevWebVersion)) {
         const prevWebVersion = parseInt(_strPrevWebVersion, 10);
         webVersion = prevWebVersion;
      } else {
         window.sessionStorage.setItem("appVersion", "10601");
      }
   }

   // console.log("webVersion", webVersion);

   const ComponentWithState = (props: P) => {
      return (
         <WrappedComponent
            {...props}
            v={webVersion}
            guideData={guideData}
            categoryData={categoryData}
            faqData={faqData}
            noticeData={noticeData}
            tosDataHandler={tosDataHandler}
            tosPrevData={tosPrevData}
            adBannerData={adBannerData}
         />
      );
   };

   return ComponentWithState;
}
